import React, { PropTypes, Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import AddressUpdate from '../components/addressUpdate';
import * as store from '../../api/localStore';
import * as adminActions from '../actions/adminActions';
import { modes } from '../constants/adminConstants';

const propTypes = {
  admin: PropTypes.object.isRequired,
  actions: PropTypes.object.isRequired,
  route: PropTypes.object.isRequired,
  params: PropTypes.object.isRequired
};

class AdminPage extends Component {
  constructor(props) {
    super(props);

    this.handleAddressApproval = this.handleAddressApproval.bind(this);
  }

  componentWillMount() {
    const { actions, route: { mode }, location: { query: { logId, token } } } = this.props;
    
    store.set("token", JSON.stringify({ access_token: token.split(' ').join('+') }));

    switch (mode) {
      case modes.addressUpdate:
        actions.getAddressUpdateDetails(logId);
        break;
    }
  }

  handleAddressApproval(data) {
    const { actions, location: { query: { logId } } } = this.props;

    actions.approveAddress(logId, { addressUpdateLogId: logId, ...data });
  }

  render() {
    const { admin, route: { mode } } = this.props;

    return (
      <div className="Admin container-fluid">
        {mode == modes.addressUpdate && <AddressUpdate {...admin.addressUpdate} onApproval={this.handleAddressApproval} />}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    admin: state.admin
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(adminActions, dispatch)
  };
}

AdminPage.propTypes = propTypes;

export default connect(mapStateToProps, mapDispatchToProps)(AdminPage);


// WEBPACK FOOTER //
// ./app/admin/containers/adminPage.js